import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

interface LoginSSOPayload {
  email: string;
}

@Injectable({
  providedIn: 'root',
})
export class LgLoginService {
  protected endpoint = '/auth/all-stars-sso';
  private httpClient = inject(HttpClient);

  public ssoLogin(data: LoginSSOPayload): Observable<{
    redirect_url: string;
  }> {
    return this.httpClient.post<{
      redirect_url: string;
    }>(`${environment.baseUrl}${this.endpoint}`, data);
  }
}
